import React from 'react';
import PropTypes from 'prop-types';

import { i18n } from '../i18n';
import * as Core from '../core';
import { useBreakpointRef } from '../hooks/useBreakpointRef';
import { DesignSystem } from '@everfi/design-system';

export const SidebarSwitcher = ({ options }) => {
  if (!options) return null;
  const BREAKPOINTS = Object.freeze([1080]);
  const BREAKPOINT_VALUES = Object.freeze([true, false]);
  const { breakpointValue } = useBreakpointRef({
    breakpoints: BREAKPOINTS,
    breakpointValues: BREAKPOINT_VALUES,
    direction: '',
  });

  return (
    <div className="sidebar-role-switcher">
      <Core.DropdownMenu
        items={options}
        menuButtonText={
          !breakpointValue && (
            <Core.Layout as="span" mr={DesignSystem.Space.SPACE_2}>
              {i18n.t('New View')}
            </Core.Layout>
          )
        }
        menuButtonIcon={<Core.Icon iconName="angle-down" />}
        w="full"
        variant="flex"
        usePortal
      />
    </div>
  );
};

SidebarSwitcher.propTypes = {
  options: PropTypes.array,
};
